export default __webpack_public_path__ + "static/media/bell.133eb9a9.svg";